import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../Auth0/Login";
import ForgetPasword from "../Auth0/Forget/ForgetPasword";
import ResetPassword from "../Auth0/Reset/ResetPassword";
import Home from "../Home/Home";
import Product from "../Product";
import Category from "../Category";
import Cart from "../Cart/Cart";
import AccountArea from "../Account/AccountArea";
import Shipping from "../Shipping/Shipping";
import FAQ from "../FAQ/FAQ";
import Checkout from "../Checkout/Checkout";
import Contact from "../Contact/Contact";
import About from "../About/About";
import OrderSummary from "../OrderSummary/OrderSummary";
import Terms from "../Terms/Terms";
import Guaranties from "../Guarantees/Guaranties";
import Privacy from "../Privacy";
import Support from "../Support/Support";
import RemoteAssistance from "../RemoteAssistance";
import Success from "../../Components/Success/success";
import axios from "axios";
import { apiBaseURL } from "../../Common/ApiHelper";
import { toast } from "react-toastify";

const Routing = () => {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const fetchProductData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getAllProduct`,
      });
      if (response?.status === 200) {
        setProducts(response.data.data);
      }
    } catch (e) {
      console.log("error", e.message);
      toast.error(e.message);
    }
  };
  const fetchCategoryData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getAllCategory`,
      });
      if (response?.status === 200) {
        setCategory(response.data.data.results);
      }
    } catch (e) {
      console.log("error", e.message);
      toast.error(e.message);
    }
  };
  useEffect(() => {
    fetchProductData();
    fetchCategoryData();
  }, []);
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgetPassword" element={<ForgetPasword />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/account_area/:id" element={<AccountArea />} />
      <Route path="/asked_questions" element={<FAQ />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/" element={<Home />} />
      {products.map((product) => {
        return (
          <Route
            exact
            path={`/product/${product.name.replace(/\s+/g, "")}`}
            element={<Product product={product} />}
          />
        );
      })}
      {category.map((item) => {
        return (
          <Route
            exact
            path={`/category/${item.name.replace(/\s+/g, "")}`}
            element={<Category item={item} />}
          />
        );
      })}
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/order_summary" element={<OrderSummary />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/guaranties" element={<Guaranties />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/success" element={<Success />} />
      <Route path="/remote_assistance" element={<RemoteAssistance />} />
    </Routes>
  );
};

export default Routing;
